<template>
    <rkm-layout-body title="Lista de unidade externa">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-unidade-externa-create' })"
                color="primary"
                authorize="store-cadastro-unidade-externa"
            >
                Cadastrar unidade externa
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/unidade-externa/List'

export default {
    components: { List },
}
</script>